import { Link2Off } from 'lucide-react';
import type { AdminUserStatus, BranchStatus, BusinessStatus } from '@quds/shared';
import { Badge, PRODUCTION_LINKING_HINT, type BadgeTone } from '@/components/ui';
import { BUSINESS_STATUS_LABELS } from './labels';

const business: Record<BusinessStatus, BadgeTone> = {
  active: 'success',
  onboarding: 'primary',
  suspended: 'warning',
  inactive: 'muted',
};

export function BusinessStatusBadge({ status }: { status: BusinessStatus }) {
  return (
    <Badge tone={business[status]} dot>
      {BUSINESS_STATUS_LABELS[status]}
    </Badge>
  );
}

export function RecordStatusBadge({ status }: { status: BranchStatus | AdminUserStatus }) {
  return (
    <Badge tone={status === 'active' ? 'success' : 'muted'} dot>
      {status === 'active' ? 'Active' : 'Inactive'}
    </Badge>
  );
}

/** Production data (license, devices, versions, sync…) is not linked in Phase 2. */
export function NotLinkedBadge({ title = PRODUCTION_LINKING_HINT }: { title?: string }) {
  return (
    <Badge tone="neutral" title={title} icon={<Link2Off size={12} aria-hidden="true" />}>
      Not linked
    </Badge>
  );
}

export function RequestedBadge({ requested }: { requested: boolean }) {
  return (
    <Badge tone={requested ? 'primary' : 'muted'} dot>
      {requested ? 'Requested' : 'Not requested'}
    </Badge>
  );
}
